/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum SpecialOrderMaterialStatus {
    SUBMITTED = 'SUBMITTED',
    CANCELLED = 'CANCELLED',
    PACKAGING = 'PACKAGING',
    PARTIALLY_SHIPPED = 'PARTIALLY_SHIPPED',
    SHIPPED = 'SHIPPED',
    DRAFT = 'DRAFT'
}
